module.exports = __webpack_public_path__ + "media/images/riders/small/TRACEY_HANNAH-9dbb62e21f402d3f0e6f21337c3274fa.png";